// Basic Use - Covers most scenarios
//import { VueEditor } from "vue2-editor";

// Advanced Use - Hook into Quill's API for Custom Functionality
import { VueEditor, Quill } from "vue2-editor";

// configure Quill to use inline styles so the email's format properly
const DirectionAttribute = Quill.import('attributors/attribute/direction');
const AlignClass = Quill.import('attributors/class/align');
const BackgroundClass = Quill.import('attributors/class/background');
const ColorClass = Quill.import('attributors/class/color');
const DirectionClass = Quill.import('attributors/class/direction');
const FontClass = Quill.import('attributors/class/font');
const SizeClass = Quill.import('attributors/class/size');
const AlignStyle = Quill.import('attributors/style/align');
const BackgroundStyle = Quill.import('attributors/style/background');
const ColorStyle = Quill.import('attributors/style/color');
const DirectionStyle = Quill.import('attributors/style/direction');
const FontStyle = Quill.import('attributors/style/font');
const SizeStyle = Quill.import('attributors/style/size');

Quill.register(DirectionAttribute,true);
Quill.register(AlignClass,true);
Quill.register(BackgroundClass,true);
Quill.register(ColorClass,true);
Quill.register(DirectionClass,true);
Quill.register(FontClass,true);
Quill.register(SizeClass,true);
Quill.register(AlignStyle,true);
Quill.register(BackgroundStyle,true);
Quill.register(ColorStyle,true);
Quill.register(DirectionStyle,true);
Quill.register(FontStyle,true);
Quill.register(SizeStyle,true);

export default {
    components: {
        VueEditor
    },
    props: {
      /**
       * The field name.
       */
      name: {
        type: String,
        required: true,
      },
  
      /**
       * The field value.
       */
      value: {
        type: [String],
        required: false,
        default: '',
      },
  
      /**
       * The base key to translate the form.
       */
      translation: {
        type: String,
        required: false,
      },
  
      /**
       * If the input has error.
       */
      error: {
        type: String,
        required: false,
      },
  
      /**
       * If the input is disabled.
       */
      disabled: {
        type: Boolean,
        default: false,
      },
  
      /**
       * If the input is clearable.
       */
      clearable: {
        type: Boolean,
        default: false,
      },
  
    },
  
    methods: {
      /**
       * This method will be called when input event is fired.
       *
       * @param  {String} name The field name.
       */
      onInput(name) {
        return (value) => {
          this.$emit('keydown', name, value);
        };
      },
    },
  
    /**
     * This function will be called to render the HTML.
     *
     * @param  {Function} h    Mandatory for vue to render JSX.
     */
    // eslint-disable-next-line
    render (h) {
        const editor = <vue-editor 
            value={this.value ? this.value.toString() : ''}
            onInput={this.onInput(this.name)}
            disabled={this.disabled}
            placeholder={this.translation ? this.$t(`${this.translation}.placeholder`) : this.name}
            name={this.name}></vue-editor>;  

        let label = null;
        if (this.hasLabel) {
          label = this.translation ? this.$t(`${this.translation}.label`) : this.name;
        }

        return (<el-form-item
                error={this.error}
                label={label}
                class={this.name}
                >
                {editor}
                </el-form-item>
                
          );
    },
  };
  


// WEBPACK FOOTER //
// ./src/app/components/form/editor/editor.jsx